module.exports = __webpack_public_path__ + "img/brackets_big.6a38501c.svg";